<template>
    <div>
        <el-dialog
            title="设置优质采商品"
            :visible="showDialog"
            width="80%"
            @close="closeDialog"
        >
            <div>
                <el-form
                    :model="youzhicaiProduct"
                    ref="youzhicaiProductForm"
                    :rules="rules"
                    label-width="120px"
                    :inline="true"
                    size="small"
                >
                    <el-tabs type="border-card">
                        <el-tab-pane label="基本信息">
                            <el-form-item
                                label="商品名称"
                                prop="goodsName"
                            >
                                <el-input
                                    style="width: 200px"
                                    size="small"
                                    placeholder="请输入商品名称"
                                    v-model="youzhicaiProduct.goodsName"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="售卖单位"
                                prop="unit"
                            >
                                <el-input
                                    style="width: 200px"
                                    size="small"
                                    placeholder="请输入单位（'个'，'条'）"
                                    v-model="youzhicaiProduct.unit"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="商品价格"
                                prop="supMallGoodsPrice"
                            >
                                <el-input
                                    placeholder="请输入商品价格"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.supMallGoodsPrice"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="市场价格"
                                prop="marketPrice"
                            >
                                <el-input
                                    placeholder="请输入市场价格"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.marketPrice"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="库存数量"
                                prop="marketPrice"
                            >
                                <el-input
                                    placeholder="请输入库存数量"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.stock"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="品牌名称"
                                prop="brandName"
                            >
                                <el-input
                                    style="width: 200px"
                                    size="small"
                                    placeholder="请输入品牌名称"
                                    v-model="youzhicaiProduct.brandName"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="商品类目"
                                prop="cateId"
                            >
                                <gidselect
                                    style="width: 200px"
                                    title="选择商品类目"
                                    labelName="cateName"
                                    labelValue="cateId"
                                    :value="youzhicaiProduct.cateId.toString()"
                                    :limit="1"
                                    size="small"
                                    placeholder="请选择商品类目"
                                    @getValue="getValue"
                                    :columns="columns"
                                    :searchs="searchs"
                                    dataListUrl="/youzhicai/category/findList"
                                    entityBeanName="youzhicaiCategory"
                                    queryEntityUrl="/youzhicai/category/get"
                                >
                                </gidselect>
                            </el-form-item>
                            <el-form-item
                                label="商品UPC"
                                prop="upc"
                            >
                                <el-input
                                    placeholder="请输入商品UPC"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.upc"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="产地省市"
                                prop="productArea"
                            >
                                <el-input
                                    placeholder="请输入产地（例:安徽,合肥)"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.productArea"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="规格型号"
                                prop="model"
                            >
                                <el-input
                                    placeholder="请输入规格型号（商品具体型号)"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.model"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="供货周期"
                                prop="deliveryTime"
                            >
                                <el-input
                                    placeholder="请输入供货周期天数"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.deliveryTime"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="最少起订"
                                prop="minBuyNum"
                            >
                                <el-input
                                    placeholder="请输入最小起订数量"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.minBuyNum"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="商品来源"
                                prop="importType"
                            >
<!--                                <el-input-->
<!--                                    placeholder="请输入商品来源"-->
<!--                                    style="width: 200px"-->
<!--                                    size="small"-->
<!--                                    v-model="youzhicaiProduct.importType"-->
<!--                                ></el-input>-->
                                <el-select
                                    placeholder="请选择商品来源"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.importType"
                                >
                                    <el-option label="供应商" value="0"></el-option>
                                    <el-option label="电商" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="物资编码"
                                prop="companyMaterialNo"
                            >
                                <el-input
                                    placeholder="请输入物资编码"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.companyMaterialNo"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="电商链接"
                                prop="supMallGoodsUrl"
                            >
                                <el-input
                                    placeholder="请输入电商免登录链接"
                                    style="width: 200px"
                                    size="small"
                                    v-model="youzhicaiProduct.supMallGoodsUrl"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="商品主图"
                                prop="imagePath"
                            >
                                <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="uploadAvatar">
                                    <img v-if="youzhicaiProduct.imagePath" :src="youzhicaiProduct.imagePath" class="avatar" size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="商品详情">
                            <el-form-item label="" prop="introduction">
                                <WangEditor ref="contentEditor" v-model="youzhicaiProduct.introduction" />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="商品属性">
                            <sku-edit ref="skuEdit" ></sku-edit>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
            </div>
            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                    type="primary"
                    @click="submitForm()"
                >推送商品
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import Gidselect from '@/components/gridselect/index.vue';
import { YOUZHICAI_CATEGORY, YOUZHICAI_SEARCH, UPLOAD_PATH  } from '@/utils/constant';
import WangEditor from '@/components/common/wangeditor.vue';
import SkuEdit from '@/components/youzhicai/skuEdit.vue';
import eventBus from '@/api/eventBus';


export default {
    components:{
        WangEditor,
        Gidselect,
        SkuEdit
    },
    props: {
        shopProduct: {
            type: Object,
            default: {}
        },
        showDialog:{
            type: Boolean,
            default: {}
        }
    },
    watch:{
        shopProduct:{
            handler(newValue){
                this.youzhicaiProduct.goodsName = newValue.productName
                this.youzhicaiProduct.supMallGoodsPrice = newValue.shopPrice
                this.youzhicaiProduct.companyMaterialNo = newValue.productNumber
                this.youzhicaiProduct.imagePath = newValue.productPic
                this.youzhicaiProduct.brandName = newValue.brand ? newValue.brand.brandName : ""
                this.youzhicaiProduct.marketPrice = newValue.marketPrice
                this.youzhicaiProduct.stock = newValue.stockSize
                this.youzhicaiProduct.introduction = newValue.productContent ? newValue.productContent : ""
                this.$refs.contentEditor.init(this.youzhicaiProduct.introduction);

                if(newValue.skuList && newValue.skuValueList){
                    this.sku.skuList = newValue.skuList;
                    this.sku.skuValueList = newValue.skuValueList;
                    eventBus.$emit('skuEdit', this.sku);
                }
            },
            deep: true
        }
    },
    data() {
        return {
            columns: YOUZHICAI_CATEGORY,
            searchs: YOUZHICAI_SEARCH,

            sku: {
                skuList: [],
                skuValueList: []
            },

            youzhicaiProduct: {
                goodsName: '', // 商品名称
                unit: '', // 单位
                imagePath: '', // 商品主图
                brandName: '', // 品牌名称
                cateId: '', // 商品类目
                upc: '', // 商品upc码
                productArea: '', // 商品产地
                model: '', // 规格型号
                introduction: '', // 商品详情
                skuId: '', // skuId
                deliveryTime: '', // 供货周期
                minBuyNum: '', // 最少起订
                importType: '', // 商品来源 0-供应商，1-电商
                companyMaterialNo: '', // 商品货号
                supMallGoodsUrl: '', // 商品在电商商城的免登录链接
                supMallGoodsPrice: '', // 商品在电商商城的价格
                marketPrice: '', // 市场价格
                stock: '', // 库存数量
            },
            rules: {
                goodsName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                unit: [{ required: true, message: '售卖单位不能为空', trigger: 'blur' }],
                imagePath: [{ required: true, message: '商品主图不能为空', trigger: 'blur' }],
                brandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
                cateId: [{ required: true, message: '商品目录不能为空', trigger: 'blur' }],
                upc: [{ required: true, message: '商品upc不能为空', trigger: 'blur' }],
                productArea: [{ required: true, message: '商品产地不能为空', trigger: 'blur' }],
                model: [{ required: true, message: '规格型号不能为空', trigger: 'blur' }],
                deliveryTime: [{ required: true, message: '供货周期不能为空', trigger: 'blur' }],
                minBuyNum: [{ required: true, message: '最少起订不能为空', trigger: 'blur' }],
                importType: [{ required: true, message: '商品来源不能为空', trigger: 'blur' }],
                companyMaterialNo: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                supMallGoodsUrl: [{ required: true, message: '免登录链接不能为空', trigger: 'blur' }],
                supMallGoodsPrice: [{ required: true, message: '商品价格接不能为空', trigger: 'blur' }],
                marketPrice: [{ required: true, message: '市场价格接不能为空', trigger: 'blur' }],
                stock:  [{ required: true, message: '库存数量接不能为空', trigger: 'blur' }],
            }
        };
    },
    methods: {
        closeDialog() {
            this.youzhicaiProduct = {
                goodsName: '', // 商品名称
                unit: '', // 单位
                imagePath: '', // 商品主图
                brandName: '', // 品牌名称
                cateId: '', // 商品类目
                upc: '', // 商品upc码
                productArea: '', // 商品产地
                model: '', // 规格型号
                introduction: '', // 商品详情
                skuId: '', // skuId
                deliveryTime: '', // 供货周期
                minBuyNum: '', // 最少起订
                importType: '', // 商品来源 0-供应商，1-电商
                companyMaterialNo: '', // 商品货号
                supMallGoodsUrl: '', // 商品在电商商城的免登录链接
                supMallGoodsPrice: '' // 商品在电商商城的价格
            }
            this.$emit("closeDialog")
        },
        submitForm() {
            this.$refs.youzhicaiProductForm.validate((valid) => {
                if(valid){
                    get('/youzhicai/product/push', {...this.youzhicaiProduct}).then((res)=>{
                        if(res.success){
                            this.closeDialog()
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                            this.$emit("closeDialog")
                        }
                    })
                }
            })
        },
        getValue(cateId){
            this.youzhicaiProduct.cateId = cateId
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.youzhicaiProduct.imagePath = res.url;
                }
            });
        },
    }
};

</script>

<style scoped lang="scss">
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
</style>